import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { BsDropdownDirective, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import Language from '../../entities/language';

@Component({
  selector: 'tvl-dropdown',
  imports: [CommonModule, BsDropdownModule],
  templateUrl: './tvl-dropdown.component.html',
  styleUrls: ['./tvl-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TvlDropdownComponent {
  @ViewChild('languagesDropdown', { static: true }) languagesDropdown: BsDropdownDirective;

  @HostListener('window:orientationchange')
  @HostListener('window:resize')
  onResizeEvent() {
    if (this.languagesDropdown.isOpen) {
      this.languagesDropdown.hide();
    }
  }

  @Input() languages: Language[] = [];
  @Input() selectedLanguage!: Language;
  @Input() isSystemSelector = false;
  @Input() isNotMobile = true;

  @Output() onLanguageChange = new EventEmitter<Language>();

  changeLanguage(language: Language): void {
    this.onLanguageChange.emit(language);
  }
}
